"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.useApptPurposeFilter = void 0;
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _react = require("react");
var _fuzzysort = _interopRequireDefault(require("fuzzysort"));
var _constants = require("../../../lib/constants");
const matchesVisitTypeFilter = (visitTypeFilterValue, purposeVisitMethod) => {
  return !visitTypeFilterValue || visitTypeFilterValue === _constants.ALL || !purposeVisitMethod && visitTypeFilterValue === _constants.IN_PERSON || purposeVisitMethod === visitTypeFilterValue;
};
const filterByName = (purposes, nameFilterValue, highlightFn) => {
  var _context;
  return nameFilterValue ? (0, _map.default)(_context = _fuzzysort.default.go(nameFilterValue, purposes, {
    key: 'name',
    limit: 25,
    threshold: -10000
  })).call(_context, r => ({
    ...r.obj,
    highlightedName: highlightFn ? _fuzzysort.default.highlight(r, highlightFn) : r.target
  })) : purposes;
};
const useApptPurposeFilter = _ref => {
  let {
    initialNameFilterValue = '',
    initialVisitTypeFilterValue = _constants.ALL,
    initialPurposes,
    highlightFn,
    onNameFilterChange,
    onVisitTypeFilterChange,
    onClearFilters
  } = _ref;
  const [isFiltered, setIsFiltered] = (0, _react.useState)(false);
  const [nameFilterValue, setNameFilterValue] = (0, _react.useState)(initialNameFilterValue);
  const [visitTypeFilterValue, setVisitTypeFilterValue] = (0, _react.useState)(initialVisitTypeFilterValue);
  const [filteredPurposes, setFilteredPurposes] = (0, _react.useState)(initialPurposes);
  const handleNameFilterChange = val => {
    var _context2;
    setNameFilterValue(val);
    const newPurposes = (0, _filter.default)(_context2 = filterByName(initialPurposes, val, highlightFn)).call(_context2, purpose => {
      return matchesVisitTypeFilter(visitTypeFilterValue, purpose.visit_method);
    });
    setFilteredPurposes(newPurposes);
    if (val === initialNameFilterValue && visitTypeFilterValue === initialVisitTypeFilterValue) {
      setIsFiltered(false);
    } else {
      setIsFiltered(true);
    }
    if (onNameFilterChange) {
      onNameFilterChange({
        nameFilterValue: val,
        visitTypeFilterValue,
        newPurposes
      });
    }
  };
  const handleVisitTypeFilterChange = val => {
    var _context3;
    setVisitTypeFilterValue(val);
    const newPurposes = (0, _filter.default)(_context3 = filterByName(initialPurposes, nameFilterValue, highlightFn)).call(_context3, purpose => {
      return matchesVisitTypeFilter(val, purpose.visit_method);
    });
    setFilteredPurposes(newPurposes);
    if (nameFilterValue === initialNameFilterValue && val === initialVisitTypeFilterValue) {
      setIsFiltered(false);
    } else {
      setIsFiltered(true);
    }
    if (onVisitTypeFilterChange) {
      onVisitTypeFilterChange({
        nameFilterValue,
        visitTypeFilterValue: val,
        newPurposes
      });
    }
  };
  const handleClearFilters = () => {
    setNameFilterValue(initialNameFilterValue);
    setVisitTypeFilterValue(initialVisitTypeFilterValue);
    setFilteredPurposes(initialPurposes);
    setIsFiltered(false);
    if (onClearFilters) {
      onClearFilters();
    }
  };
  return {
    isFiltered,
    nameFilterValue,
    visitTypeFilterValue,
    filteredPurposes,
    handleNameFilterChange,
    handleVisitTypeFilterChange,
    handleClearFilters
  };
};
exports.useApptPurposeFilter = useApptPurposeFilter;